// UNUSED: the app renders without StrictMode: in dev it runs every effect and query twice, which
// doubled the Match Lab's calls in its performance runs. Kept for the review.
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { markRum } from "./app/page-trace";
import { initRum } from "./app/rum";
import { loadConfig } from "./config";
import "./i18n";
import "./styles/index.css";

void StrictMode;

/**
 * `/config.json` first: the API base path and the sign-in settings come from it, written per
 * environment at container start (`docker-entrypoint.sh`). The app's modules load after it, so
 * they read the loaded values (`runtimeConfig()`).
 */
async function bootstrap() {
  markRum("boot");
  await loadConfig();
  // Before the app renders, so a render-time failure in App's very first tick is still caught
  // by the agent's own default window.onerror/unhandledrejection hooks.
  initRum();
  const { App } = await import("./App");
  const rootElement = document.getElementById("root");
  if (!rootElement) {
    throw new Error("Root element not found");
  }
  createRoot(rootElement).render(<App />);
}

void bootstrap();
